<script>
import Report from '@views/report.vue'

export default {
  components: { Report },
  computed: {
    reportId() {
      const parts = window.location.pathname.split('/');
      if(parts.length > 1 && parts[1].length) {
        return parts[1];
      }
      return null;
    }
  }
}
</script>

<template>
  <div id="app">
    <Report :id="reportId" />
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';
// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';

// Design variables and utilities from src/design.
@import '@design';

*,
*::before,
*::after {
  box-sizing: border-box;
}
html {
  height: 100%;
}
body {
  height: 100%;
  background: $color-body-bg;
}
#app {
  height: 100%;

  @extend %typography-small;
}

ul {
  padding: 0;
  list-style-type: none;
}
li {
  list-style-type: none;
}
a,
a:visited {
  color: $color-link-text;
  text-decoration: none;
}
a:hover {
  color: $color-link-text
}
a,*[role="button"] {
  cursor: pointer;
}
h1 {
  margin-bottom: 0;
  font-weight: bold;

  @extend %typography-large;
}

h2 {
  font-weight: bold;

  @extend %typography-xlarge;
}

h3 {
  font-weight: 900;

  @extend %typography-xxlarge;
}

h4 {
  @extend %typography-xlarge;
}

h5,
h6 {
  @extend %typography-small;
}
</style>
